import moment from "moment/moment";

export const formatPrice = (price) => price.toLocaleString("ru-RU", { style: "currency", currency: "RUB" });

/*
 Меняет подставляет домен шопа (REACT_APP_API_URL)  в url отеля и редиректит на эту ссылку
*/
export const changeHotel = (val) => {
  const currentUrl = new URL(window.location.href);
  const hotelUrl = new URL(val);
  let shopDomain = process.env.REACT_APP_API_URL.slice(0,-1);
  const newUrl = shopDomain + hotelUrl.pathname + '?' + currentUrl.searchParams.toString();
  window.location.href = newUrl;
};

export const formatDatesFromTo = (from, to) => {
  const fromM = moment(from);
  const toM = moment(to);

  return `${fromM.format('DD.MM.YY')} - ${toM.format('DD.MM.YY')}`
};

export const fetchMinPrice = (fetchBody) => {
  return fetch(process.env.REACT_APP_API_URL_DIRECTLY_REPLICA + 'api/hotels/min_price', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(fetchBody)
  })
}

export const isCurrentHotel = (url) => {
  const currentUrl = new URL(window.location.href);
  const hotelUrl = new URL(url);
  return currentUrl.pathname === hotelUrl.pathname;
};